'use strict'

const $ = window.jQuery;

export default function () {
    $('.custom-filter').on('click', function () {
        const custom = $(this).data('custom');

        $('.custom-filter').removeClass('checked');
        $(this).addClass('checked');

        if (custom === 'all-custom') {
            $('.custom-filters-section').removeClass('is-active filtered');
        } else {
            $('.custom-filters-section').removeClass('is-active').addClass('filtered');
            $(`#${custom}`).removeClass('filtered').addClass('is-active');
        }
    });

    $('#customReset').on('click', function () {
        $('.custom-filter').removeClass('checked');
        $('.custom-filter--reset').addClass('checked');
        $('.custom-filters-section').removeClass('is-active filtered');
    });
};
